import { render, staticRenderFns } from "./ValueItem.vue?vue&type=template&id=7f5a03bd"
import script from "./ValueItem.vue?vue&type=script&lang=js"
export * from "./ValueItem.vue?vue&type=script&lang=js"
import style0 from "./ValueItem.vue?vue&type=style&index=0&id=7f5a03bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports